<template>
    <div>
        <div class="main-content" id="panel">
            <header-component></header-component>
            <!-- Header -->
            <div class="header pb-5 bg-gradient-gray-dark">
                <div class="container">
                    <div class="header-body">
                        <div class="row py-5">
                            <!--nombre del curso-->
                            <div class="col-1">
                                <img src="assets/img/docente/grupos-01.svg" class="pl-8">
                            </div>
                            <div class="col-9 text-center text-white">
                                <h1 class="text-white">Administración de grupos</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Page content -->
            <div class="container-fluid mt--6">
                <div class="card col-10 mx-auto">
                    <!-- Card body -->
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-6">
                                <a href="#" class="btn btn-secondary"><i class="fa fa-download"></i> Descargar guía</a>
                            </div>
                            <div class="col-md-6">
                                <router-link to="/group-info" class="btn btn-secondary float-right"><i class="fa fa-plus-circle"></i> Agregar nuevo grupo</router-link>
                            </div>
                        </div>
                        <br><br>
                        <div class="row">
                            <div class="col-md-12 text-center">
                                <h2>Buscar grupos</h2>
                                <p>En esta sección se puede buscar, crear y editar grupos</p>
                            </div>
                        </div><!--termina row de header-->
                        <div class="row">
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label class="form-control-label" for="example3cols1Input">Nombre o clave de grupo:</label>
                                    <input type="text" class="form-control" id="example3cols1Input" placeholder="Nombre/clave">
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label class="form-control-label" for="educationLevel">Nivel educativo</label>
                                    <b-form-select v-model="model.educationLevel" :options="educationLevel" id="educationLevel" name="educationLevel" value-field="id" text-field="sOption" required @change="getGrades"></b-form-select>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label class="form-control-label" for="grade">Grado</label>
                                    <b-form-select v-model="model.grade" :options="grades" id="grade" name="grade" value-field="id" text-field="sOption" required></b-form-select>
                                </div>
                            </div>
                            <button href="#" class="btn btn-primary mx-auto" @click="searchGroups" v-if="model.grade > 0"><i class="fa fa-search"></i> Buscar</button>
                        </div><!--termina row-->
                    </div>
                </div>
                <!--termina card-->
                <div class="card">
                    <!-- Card header -->
                    <div class="card-header border-0">
                        <div class="row">
                            <div class="col-12">
                                <p class="mb-0">Use los iconos para administrar sus grupos: <span><i class="fa fa-edit text-gray"></i> (editar)</span> o <span><i class="fa fa-trash text-gray"></i> (eliminar)</span></p>
                            </div>
                        </div>
                    </div>
                    <!-- Light table -->
                    <div class="table-responsive">
                        <table class="table align-items-center table-flush">
                            <thead class="thead-light">
                                <tr>
                                    <th>Clave del grupo</th>
                                    <th>Nombre del grupo</th>
                                    <th>Nivel educativo</th>
                                    <th>Vigencia</th>
                                    <th>Alumnos</th>
                                    <th>Activo</th>
                                    <th>Opciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="group in groups" :key="group.idGroup">
                                    <td><b>{{ group.sKey }}</b></td>
                                    <td><span class="text-muted">{{ group.sGroup }}</span></td>
                                    <td><a class="font-weight-bold">{{ group.sGrade }}</a></td>
                                    <td><span class="text-muted">{{ group.dUTCStartDate.substring(0, 10) }} al {{ group.dUTCFinishDate.substring(0, 10) }}</span></td>
                                    <td>{{ group.iStudent }}</td>
                                    <td>
                                        <div class="custom-control custom-checkbox">
                                            <input class="custom-control-input" id="table-check-all" type="checkbox" :checked="group.bActive" disabled>
                                            <label class="custom-control-label" for="table-check-all"></label>
                                        </div>
                                    </td>
                                    <td class="table-actions">
                                        <a href="#!" class="table-action" data-toggle="tooltip" data-original-title="Editar">
                                            <i class="fa fa-edit"></i>
                                        </a>
                                        <a href="#!" class="table-action table-action-delete" data-toggle="tooltip" data-original-title="Eliminar">
                                            <i class="fas fa-trash"></i>
                                        </a>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <!--termina card-->
            </div>
        </div>
    </div>
</template>
<script>
import NavigationComponent from '@/components/NavigationComponent'
import HeaderComponent from '@/components/HeaderComponent'
import VueForm from "vue-form"
import options from "../validations/validations.js";
Vue.use(VueForm, options);
export default {
    name: 'AdminGroups',
    components: {
        NavigationComponent, HeaderComponent
    },
    data() {
        return {
            usuario: {},
            hostname: '',
            educationLevel: [],
            grades: [],
            groups: [],
            model: {
                educationLevel: '',
                grade: '',
            }
        }
    },
    methods: {
        async getEducationLevel() {
            this.openLoading()
            await axios.get(apiKS + 'api/rpt-ethinking/json/educationLevel', { headers: clientAPI })
            .then( (response) => {
                Swal.close()
                this.educationLevel = response.data.options
            })
            .catch( error => {
                this.catchError(error)
            })
        },
        async getGrades(value) {
            this.openLoading()
            await axios.get(apiKS + 'api/rpt-ethinking/json/grades?idEduLevel=' + value, { headers: clientAPI })
            .then( (response) => {
                Swal.close()
                this.grades = response.data.options
            })
            .catch( error => {
                this.catchError(error)
            })
        },
        async searchGroups() {
            this.openLoading()
            await axios.get(apiKS + 'api/rpt-ethinking/json/teacherGroups', { headers })
            .then( (response) => {
                Swal.close()
                this.groups = response.data.groups
            })
            .catch( error => {
                this.catchError(error)
            })
        }
    },
    async mounted() {
        this.hostname = hostname
        if(!user) {
            await this.getUserApi()
            this.usuario = user
        } else {
            this.usuario = user
        }

        await this.getEducationLevel()
    },
    beforeMount() {
        document.body.classList.remove('bg-mos1')
    },
    watch: {
        
    }
}
</script>